<template>
    <div>
        <video ref="video" class="video-js"></video>
    </div>
</template>

<script>

import 'video.js/dist/video-js.css'
import videojs from 'video.js'
import 'videojs-seek-buttons'
import 'videojs-seek-buttons/dist/videojs-seek-buttons.css'
import offset from 'videojs-offset'

export default {
    name: "VideoPlayer",
    props: {
        trim_offset: {
            type: Object,
            default() {
                return null;
            }
        },
        // is_list: {
        //     type: Boolean,
        //     default() {
        //         return false;
        //     }
        // },
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        /*globalOptions: {
            type: Object,
            default: () => ({
                // document: https://docs.videojs.com/tutorial-options.html#fluid
                autoplay: true,
                controls: true,
                language: 'en',
                inactivityTimeout: 0,
                preload: 'auto',
                fluid: false,
                techOrder: ['html5'],
                plugins: {
                    seekButtons: {
                        forward: 10,
                        back: 5
                    }
                },
                playbackRates: [0.5, 1, 1.5, 2],
            })
        },*/

        playsinline: {
            type: Boolean,
            default: false
        },
        crossOrigin: {
            type: String,
            default: ''
        },
        events: {
            type: Array,
            default: () => []
        },
        globalEvents: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            player: null,
            is_playing: false,
            is_full_screen: false,

            globalOptions: {
                autoplay: true,
                controls: true,
                language: 'en',
                inactivityTimeout: 2000,
                preload: 'auto',
                fluid: false,
                techOrder: ['html5'],
                plugins: {
                    seekButtons: {
                        forward: 10,
                        back: 5
                    }
                },
                // controlBar: {
                //     seekToLive: false
                // },
                playbackRates: [0.5, 1, 1.5, 2]
            },
        }
    },
    created() {
        //if (!this.is_list) {
        // this.globalOptions.plugins.seekButtons = {
        //     forward: 10,
        //     back: 5
        // }
        // this.globalOptions.playbackRates = [0.5, 1, 1.5, 2]
        //}
        // this.EventBus.on('videoseek', (time) => {
        //     if (this.player) {
        //         if (!this.is_playing) {
        //             this.player.play()
        //         }
        //         console.log("seek to ", time)
        //         this.player.currentTime(time)
        //     }
        // })

        // Only register the plugin if it hasn't been registered yet
        if (!videojs.getPlugin('offset')) {
            videojs.registerPlugin("offset", offset);
        }

        if (this.trim_offset) {
            this.globalOptions.plugins.offset = {
                start: this.trim_offset.start,
                end: this.trim_offset.end,
                restart_beginning: false
            }
        }
    },
    mounted() {
        if (!this.player) {
            this.initialize()
        }
    },

    methods: {
        initialize: function () {

            const self = this
            const videoObj = this.$refs.video
            // videojs options
            const videoOptions = Object.assign({}, this.globalOptions, this.options)
            // ios fullscreen
            if (this.playsinline) {
                videoObj.setAttribute('playsinline', this.playsinline)
                videoObj.setAttribute('webkit-playsinline', this.playsinline)
                videoObj.setAttribute('x5-playsinline', this.playsinline)
                videoObj.setAttribute('x5-video-player-type', 'h5')
                videoObj.setAttribute('x5-video-player-fullscreen', false)
            }
            // cross origin
            if (this.crossOrigin !== '') {
                videoObj.crossOrigin = this.crossOrigin
                videoObj.setAttribute('crossOrigin', this.crossOrigin)
            }
            // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
            if (videoOptions.plugins) {
                delete videoOptions.plugins.__ob__
            }
            // emit event
            const emitPlayerState = (event, value) => {
                if (event) {
                    // console.log("event", event, this.is_playing)
                    // Eviter de passer en pause au changement fullscreen on ou off
                    if (event == "playing" || event == "pause") {
                        //console.log("event", event)
                        // console.log("is_playing", this.is_playing)
                        // console.log("isFullscreen_", this.player.isFullscreen_)
                        // console.log("is_full_screen", this.is_full_screen)
                        if (event == "playing" && !this.is_playing) {
                            this.is_playing = true
                            setTimeout(function () {
                                this.is_full_screen = this.player.isFullscreen_
                            }.bind(this), 300)
                        } else if (event == "pause" && this.is_playing) {
                            this.is_playing = false
                            setTimeout(function () {
                                if (this.is_full_screen != this.player.isFullscreen_) {
                                    //console.log("Should restart")
                                    this.player.play()
                                }
                                this.is_full_screen = this.player.isFullscreen_
                            }.bind(this), 300)
                            //this.is_full_screen = this.player.isFullscreen_
                        }
                    } else {
                        this.is_full_screen = this.player.isFullscreen_
                    }

                    // console.log("emitPlayerState", event, this.player)
                    this.$emit(event, this.player)
                }
                // if (value) {
                //     console.log("emitPlayerState value", value)
                //     this.$emit(this.customEventName, { [event]: value })
                // }
            }
            // player
            this.player = videojs(videoObj, videoOptions, function () {
                // events
                const DEFAULT_EVENTS = [
                    'loadeddata',
                    'canplay',
                    'canplaythrough',
                    'play',
                    'pause',
                    'waiting',
                    'playing',
                    'ended',
                    'error',
                    'fullscreenchange',
                    'exitFullWindow',
                    'timeupdate',
                    'seeked',
                    'volumechange',
                    'useractive',
                    'userinactive'
                ]
                const events = DEFAULT_EVENTS.concat(self.events).concat(self.globalEvents)
                // watch events
                const onEdEvents = {}
                for (let i = 0; i < events.length; i++) {
                    if (
                        typeof events[i] === 'string' &&
                        onEdEvents[events[i]] === undefined
                    ) {

                        (event => {
                            onEdEvents[event] = null
                            this.on(event, () => {
                                //console.log("Emit event for ", event)
                                emitPlayerState(event, true)
                            })
                        })(events[i])
                    }
                }
                // player readied
                self.$emit('ready', this)
                // if (self.trim_offset) {
                //     self.player.offset({
                //         start: self.trim_offset.start, // seconds
                //         end: self.trim_offset.end,   // seconds
                //         restart_beginning: false
                //     })
                //     console.log("trim_offset", self.trim_offset)
                // } else {
                //     console.log("no trim_offset")
                // }
            })
            // if (this.trim_offset) {
            //     videojs.registerPlugin("offset", offset);
            //     this.player.offset({
            //         start: this.trim_offset.start,
            //         end: this.trim_offset.end,
            //         restart_beginning: false
            //     })
            // }

            const liveDisplay = document.querySelector('.vjs-live-control .vjs-live-display');
            if (liveDisplay) {
                liveDisplay.innerHTML = 'Preparing video…';
            }
        },
        dispose(callback) {
            if (this.player && this.player.dispose) {
                if (this.player.techName_ !== 'Flash') {
                    this.player.pause && this.player.pause()
                }
                this.player.dispose()
                this.player = null
                this.$nextTick(() => {
                    this.reseted = false
                    this.$nextTick(() => {
                        this.reseted = true
                        this.$nextTick(() => {
                            callback && callback()
                        })
                    })
                })
            }
        }
    },
    watch: {
        options: {
            deep: true,
            handler(options, oldOptions) {
                this.dispose(() => {
                    if (options && options.sources && options.sources.length) {
                        this.initialize()
                    }
                })
            }
        }
    },
    beforeUnmount() {
        if (this.player) {
            this.dispose()
        }
    }
}
</script>
<style>
.video-js .vjs-control-bar {
    height: 5em !important;
    width: 96%;
    left: 2%;
    right: 2%;
    bottom: 13px;
    border-radius: 6px;
}

.video-js.is_list .vjs-control-bar {
    bottom: 6px;
}

.video-js .vjs-live-control {
    align-items: center;
    font-size: 12px;
    color: #fff;
}

.vjs-icon-play::before,
.video-js .vjs-play-control .vjs-icon-placeholder::before,
.video-js .vjs-big-play-button .vjs-icon-placeholder::before,
.vjs-icon-volume-mid::before,
.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder::before,
.video-js .vjs-mute-control .vjs-icon-placeholder::before,
.vjs-icon-volume-high::before {
    margin-top: 0.23em;
}

.vjs-button>.vjs-icon-placeholder::before {
    font-size: 2.4em;
    line-height: 1.67;
    margin-top: 0.16em;
}

.video-js .vjs-fullscreen-control {
    margin-top: 0.16em;
}

.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {
    margin-top: 0.9em;
}

.video-js .vjs-time-control {
    font-weight: bold;
    font-size: 1.2em;
    line-height: 4.1em;
}

.vjs-playback-rate>.vjs-menu-button,
.vjs-playback-rate .vjs-playback-rate-value {
    top: 0.60em;
    font-weight: bold;
}

.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
    border-radius: 0.4em;
    overflow: hidden;
    background: #5F5F5F;
    bottom: 3em;
}

.video-js.vjs-v6 .vjs-seek-button.skip-forward .vjs-icon-placeholder::before,
.video-js.vjs-v7 .vjs-seek-button.skip-forward .vjs-icon-placeholder::before {
    left: -4px;
}

/* .video-js.vjs-v6 .vjs-seek-button.skip-forward .vjs-icon-placeholder::after,
.video-js.vjs-v7 .vjs-seek-button.skip-forward .vjs-icon-placeholder::after {
    content: '10';
    font-family: Arial, Helvetica, sans-serif;
    line-height: 6.7em;
    font-weight: bold;
    text-align: left;
    padding-left: 22px;
    font-size: 0.9em;
} */
.video-js .vjs-seek-button.skip-back::before,
.video-js.vjs-v6 .vjs-seek-button.skip-back .vjs-icon-placeholder::before,
.video-js.vjs-v7 .vjs-seek-button.skip-back .vjs-icon-placeholder::before {
    left: 4px;
}

/* .video-js .vjs-seek-button.skip-back::after,
.video-js.vjs-v6 .vjs-seek-button.skip-back .vjs-icon-placeholder::after,
.video-js.vjs-v7 .vjs-seek-button.skip-back .vjs-icon-placeholder::after {
    content: '5';
    font-family: Arial, Helvetica, sans-serif;
    line-height: 6.7em;
    font-weight: bold;
    text-align: left;
    padding-left: 0px;
    font-size: 0.9em;
} */
.video-js .vjs-picture-in-picture-control .vjs-icon-placeholder:before,
.vjs-icon-picture-in-picture-enter:before {
    margin-top: 0.22em;
}

.vjs-paused.vjs-user-inactive .vjs-control-bar {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.5s ease;
    /* Smooth transition for hiding */
}

.vjs-paused.vjs-user-active .vjs-control-bar {
    opacity: 1;
    pointer-events: auto;
}
</style>
